import $ from 'jquery';
import moment from 'moment';
import React, { Component } from 'react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';

class OnTheWay extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;



        var sid = Context.GetContext().Sid;
        var items = Comm.OnTheWay({ session: sid });
        var taxGroups = Comm.CallServerFunction("invoices/tax_groups", { session: sid });



        this.state = {
            ArriveDialog: false,
            TaxGroups: taxGroups.data.tax_groups,
            DefaultTaxGroup: taxGroups.data.default_group,

            Items: items
        };

        this.SetArrived = this.SetArrived.bind(this);
        this.ShowArriveDialog = this.ShowArriveDialog.bind(this);
        this.HandleChange = this.HandleChange.bind(this);
        this.ChangeDate = this.ChangeDate.bind(this);


        this.json = [
            {
                id: 1,
                data: "kor"
            },
            {
                id: 2,
                data: "kor1"
            },

        ];
    }


    ChangeDate(date) {

        this.setState({ Date: date });
    }

    HandleChange(id, e) {
        var arrivedItems = this.state.ArrivedItems.slice();
        for (var i = 0; i < arrivedItems.length; i++)
            if (arrivedItems[i].article === id) {
                arrivedItems[i].realweight = e.target.value;
                break;
            }


        this.setState({ ArrivedItems: arrivedItems });
    }


    ShowArriveDialog(id) {
        var result = Comm.GetOnWayDetails({
            session: Context.GetContext().Sid,
            delivery: id
        });
        this.setState(
            {
                ArriveDialog: true,
                ArrivedItems: result || [],
                ID: id,
                Date: moment().startOf('day'),
                transport_sum: 0,
                transport_currency: "EUR",
                transport_exchange_rate: 1.95583,
                transport_tax_group: this.state.DefaultTaxGroup

            }
        )
    }

    SetArrived() {
        var sid = Context.GetContext().Sid;
        var arr = [];
        $(this.state.ArrivedItems).each(function (i, e) {
            arr.push({
                article: e.article,
                qty: e.realweight || 0
            })
        });
        var obj = {
            session: sid,
            delivery: this.state.ID,
            date: this.state.Date.format("YYYYMMDD"),
            qtys: JSON.stringify(arr),
            transport_sum: this.state.transport_sum,
            transport_currency: this.state.transport_currency,
            transport_exchange_rate: this.state.transport_exchange_rate,
            transport_tax_group: this.state.transport_tax_group
        };
        Comm.SetArrived(
            obj
        );
        var items = Comm.OnTheWay({ session: sid });



        this.setState({
            ArriveDialog: false,
            Items: items
        });

    }



    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;

        var self = this;
        return (
            Context.HasRight("rontheway") ?
                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("onroad")}</div>
                    <div className="panel-body">
                        {
                            this.state.ArriveDialog ?
                                <table className="table table-striped">
                                    <tr>
                                        <td colspan="1">
                                            <b className="pull-right">{Translation.Trans("date")}</b>
                                        </td>
                                        <td colspan="1">
                                            <Datetime
                                                inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                                dateFormat="DD.MM.YYYY"
                                                timeFormat="HH:mm:ss"
                                                onChange={this.ChangeDate}
                                                value={this.state.Date}
                                                closeOnSelect="true"
                                            ></Datetime>
                                        </td>
                                        <td colspan="1">
                                            <b className="pull-right">{Translation.Trans("transportprice")}</b>
                                        </td>
                                        <td colspan="1">
                                            <input type="number" className="form-control" value={self.state.transport_sum} onChange={(e) => self.setState({ transport_sum: e.target.value })}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4"><br /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="1">
                                            <b className="pull-right">{Translation.Trans("transportcurrency")}</b>
                                        </td>
                                        <td colspan="1">
                                            <input type="text" className="form-control" value={self.state.transport_currency} onChange={(e) => self.setState({ transport_currency: e.target.value })}></input>
                                        </td>
                                        <td colspan="1">
                                            <b className="pull-right">{Translation.Trans("transportexchangerate")}</b>
                                        </td>
                                        <td colspan="1">
                                            <input type="number" className="form-control" value={self.state.transport_exchange_rate} onChange={(e) => self.setState({ transport_exchange_rate: e.target.value })}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4"><br /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="1">
                                            <b className="pull-right">{Translation.Trans("taxgroup")}</b>
                                        </td>
                                        <td colspan="1">
                                            <select className="form-control" value={self.state.transport_tax_group} onChange={(e) => self.setState({ transport_tax_group: e.target.value })}>
                                                {self.state.TaxGroups.map(x => <option value={x.id}>{x.code} {x.dds_perc}%</option>)}

                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4"><br /></td>
                                    </tr>
                                    <tr>
                                        <td><b>{Translation.Trans("article")}</b></td>
                                        <td><b>{Translation.Trans("declared")}</b></td>
                                        <td><b>{Translation.Trans("arrived")}</b></td>
                                        <td></td>
                                    </tr>
                                    {
                                        this.state.ArrivedItems.map(
                                            (obj, i) =>
                                                <tr>
                                                    <td>{obj.name}</td>
                                                    <td>{obj.weight}</td>
                                                    <td><input type="number" onChange={(e) => this.HandleChange(obj.article, e)} value={obj.realweight || 0}></input></td>
                                                    <td></td>
                                                </tr>
                                        )
                                    }
                                    <tr>
                                        <td>
                                            <button type="button" className="btn btn-primary" onClick={this.SetArrived}>{Translation.Trans("save")}</button>

                                        </td>
                                        <td>
                                            <button type="button" className="btn btn-default" onClick={() => this.setState({ ArriveDialog: false })}>{Translation.Trans("cancel")}</button>

                                        </td>
                                        <td>

                                        </td>
                                    </tr>

                                </table>
                                :

                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{Translation.Trans("contragent")}</th>
                                            <th>{Translation.Trans("invoicenumber")}</th>
                                            <th>{Translation.Trans("invoicedate")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.Items.deliveries !== null ?
                                            this.state.Items.deliveries.map(
                                                item => <tr>
                                                    <td>{item.partner_name}</td>
                                                    <td>{item.invoice_nom}</td>
                                                    <td>{moment(item.invoice_date).format("DD.MM.YYYY")}</td>
                                                    <td>
                                                        {Context.HasRight("eontheway") ?
                                                            <button key={item.id} className="btn btn-default" onClick={() => this.ShowArriveDialog(item.id)}>{Translation.Trans("arrived")}</button>
                                                            : null
                                                        }
                                                    </td>
                                                </tr>

                                            )
                                            : null}
                                    </tbody>
                                </table>
                        }
                    </div>


                </div>
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }

}


export default OnTheWay;


// WEBPACK FOOTER //
// ./src/pages/ontheway.js